var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 45.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1,37h5.54V8.7H25.12a2.17,2.17,0,0,1-.27-4.34H45.58A4.35,4.35,0,0,1,50,8.78V36.83a4.36,4.36,0,0,1-3.61,4.41,4.9,4.9,0,0,1-.77.07H40c.24.23.43.42.61.61a2.17,2.17,0,0,1-2.87,3.25L37.53,45c-1.4-1.41-2.82-2.81-4.22-4.23A2.17,2.17,0,0,1,32.94,38a3.19,3.19,0,0,1,.33-.4q2.13-2.15,4.28-4.28a2.16,2.16,0,0,1,3.55.59,2.07,2.07,0,0,1-.34,2.32,9.09,9.09,0,0,1-.72.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,8.72H4.36V37H24.9A2.18,2.18,0,1,1,25,41.31H4.41A4.36,4.36,0,0,1,0,37.41a5.24,5.24,0,0,1,0-.56V8.74A4.34,4.34,0,0,1,4.4,4.35H9.93a1.41,1.41,0,0,0-.14-.17l-.45-.46A2.17,2.17,0,1,1,12.41.65c.83.81,1.65,1.64,2.47,2.47l1.81,1.81a2.16,2.16,0,0,1,0,3.18l-4.25,4.25A2.18,2.18,0,1,1,9.37,9.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,32.61a9.78,9.78,0,1,1,9.79-9.79A9.79,9.79,0,0,1,25,32.61Zm-5.42-9.8A5.43,5.43,0,1,0,25,17.4,5.44,5.44,0,0,0,19.57,22.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCamera);
export default __webpack_public_path__ + "static/media/flip-camera.314399cf238943d4c8351f01dcaf9ac6.svg";
export { ForwardRef as ReactComponent };